import { cn } from '@/shared/lib/utils';
import type { BarSegment, JobVisualStatus } from './jobsModel';

const TONE_CLASS: Record<JobVisualStatus, string> = {
  queued: 'bg-phx-border-2',
  running: 'bg-phx-info',
  done: 'bg-phx-success',
  error: 'bg-phx-danger',
};

interface JobSegmentedBarProps {
  segments: readonly BarSegment[];
  /** Výška/šířka/radius řídí volající (`h-[6px]`, `w-[84px] h-[5px]`, …). */
  className?: string;
}

/**
 * Segmentovaný progress bar dle designu: 2px mezery, jeden segment na list (barva dle stavu),
 * nad 120 listů agregace do max. 4 proporcionálních bloků (řeší `jobsModel`).
 * `flexGrow` segmentu je runtime geometrie → inline style (povolená výjimka z Tailwind-first).
 */
export function JobSegmentedBar({ segments, className }: JobSegmentedBarProps) {
  return (
    <span
      className={cn('bg-phx-surface-2 flex gap-[2px] overflow-hidden rounded-[3px]', className)}
      aria-hidden
    >
      {segments.map((segment, index) => (
        <span
          // Pořadí segmentů je stabilní (stromové pořadí listů / pevné pořadí tónů) → index je bezpečný klíč.

          key={index}
          className={cn('transition-colors duration-300', TONE_CLASS[segment.tone])}
          style={{ flex: `${segment.grow} 1 0%` }}
        />
      ))}
    </span>
  );
}
